import { motion } from 'framer-motion'
import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'

export const LayoutWrapper = styled(motion.div)`
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
`

export const ScrollableContent = styled('div')`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-bottom: 16px;

    & > * {
        flex-shrink: 0;
    }
`

export const FooterArea = styled('div')<{ theme?: TTheme }>`
    flex-shrink: 0;
    position: sticky;
    bottom: 0;
    background-color: ${({ theme }) => theme.colors.semantic.drawerBackground};
`
